import { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import TvCard from '@/components/base/TvCard';
import { tvSeriesList } from '@/mocks/tvSeries';
import { useFavorites } from '@/hooks/useFavorites';

const PAGE_SIZE = 8;

export default function FeaturedSeries() {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const { isFavorite, toggleFavorite } = useFavorites();

  const sorted = [...tvSeriesList].sort((a, b) => b.popularity - a.popularity);
  const shown = sorted.slice(0, visible);

  return (
    <section>
      <SectionHeading
        title="精选电视剧推荐"
        subtitle="最新热播与高分口碑剧集，一网打尽"
        action={
          <Link
            to="/category/tv-series"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-label text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多剧集
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {shown.map((series) => (
          <TvCard key={series.id} series={series} favorite={isFavorite(series.id)} onToggleFavorite={toggleFavorite} />
        ))}
      </div>
      {visible < sorted.length ? (
        <div className="flex justify-center mt-8">
          <button
            type="button"
            onClick={() => setVisible((prev) => Math.min(prev + 4, sorted.length))}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-md border border-primary-300 text-primary-700 text-sm font-label hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-add-line"></i>
            加载更多剧集
          </button>
        </div>
      ) : (
        <p className="text-center text-sm text-foreground-500 mt-8">已经看完啦，去分类页发现更多内容 →</p>
      )}
    </section>
  );
}